import React from "react";
import { useNavigate } from "react-router-dom";

export function Header() {
  const navigate = useNavigate();
  return (
    <header className="fixed top-0 z-50 w-full bg-white/90 backdrop-blur-md border-b border-slate-200/80 transition-all">
      <div className="flex items-center justify-between px-6 lg:px-8 py-3.5">
        {/* Brand / Logo */}
        <div
          className="flex items-center gap-3 cursor-pointer group select-none"
          onClick={() => navigate('/')}
        >
          <div className="w-10 h-10 rounded-xl bg-gradient-to-tr from-primary to-indigo-500 flex items-center justify-center shadow-md shadow-primary/20 group-hover:scale-105 transition-transform duration-200">
            <img alt="Logo" className="w-6 h-6 object-contain brightness-0 invert" src="images/logo.svg" />
          </div>
          <div className="flex flex-col">
            <div className="flex items-center gap-2">
              <span className="font-extrabold text-xl tracking-tight text-slate-900 group-hover:text-primary transition-colors">
                Epca
              </span>
              <span className="px-2 py-0.5 text-[10px] font-bold tracking-wide uppercase bg-primary-light text-primary rounded-md">
                IoT v1.0
              </span>
            </div>
            <span className="text-xs text-slate-500 font-medium hidden sm:inline">
              Monitoreo Ambiental en Tiempo Real
            </span>
          </div>
        </div>

        {/* Status Indicators & Metadata */}
        <div className="flex items-center gap-4">
          <div className="hidden sm:flex items-center gap-2 px-3 py-1.5 rounded-full bg-emerald-50 border border-emerald-200/60 text-emerald-700 text-xs font-semibold shadow-xs">
            <span className="relative flex h-2.5 w-2.5">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-emerald-500"></span>
            </span>
            <span>Sensor Online • ESP8266</span>
          </div>

          <div className="text-right hidden md:block border-l border-slate-200 pl-4">
            <div className="text-xs font-bold text-slate-700">Grupo Técnico Basse Ltda</div>
            <div className="text-[11px] text-slate-400 font-medium">Estación de Monitoreo</div>
          </div>
        </div>
      </div>
    </header>
  );
}

